import React from 'react';

import {Helmet, useNavigate, useParams} from 'views/module';

import LoomLeadViewScene from 'views/scenes/loom_lead/detail/LoomLeadView';

import FLAGS, {useFlag} from 'utils/feature_flags/flags';

const LoomLeadView = () => {
  const params = useParams();
  const clientId = params.clientId;
  const clientReadFlag = useFlag(FLAGS.CLIENT_READS_FROM_LOOM);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (clientReadFlag.isLoading || clientReadFlag.isEnabled) return;

    navigate('/client_lead', {replace: true});
  }, [clientReadFlag.isEnabled, clientReadFlag.isLoading, navigate]);

  if (clientReadFlag.isLoading || !clientReadFlag.isEnabled) return null;

  return (
    <>
      <Helmet>
        <title>Quilt: Lead Details (Loom)</title>
      </Helmet>
      <LoomLeadViewScene
        clientId={clientId}
      />
    </>
  );
};

export default LoomLeadView;
